export default "__VITE_ASSET__BHeGBmUF__"